import config from "./config";

const baseUri = config.BACKEND_URI + config.API_PATH + "/";

export class ApiBase
{
    protected getUrl(relativeUri: string)
    {
        return `${baseUri}${relativeUri}`;
    }

    protected async get<T>(relativeUri: string): Promise<T>
    {
        // TODO handle common errors here
        const res = await this.fetch(relativeUri);
        const result = await res.json() as T;
        return result;
    }

    protected fetch(relativeUri: string, options?: RequestInit)
    {
        return fetch(this.getUrl(relativeUri), options);
    }

    protected async fetchAsync(method: string, url: string, body?: any): Promise<any>
    {
        const response = await this.fetch(url,
            {
                body: body ? JSON.stringify(body) : null,
                method,
                headers:
                {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                }
            });

        return response.json();
    }
}


// WEBPACK FOOTER //
// ./src/services/ApiBase.ts